import UIkit from 'uikit/dist/js/uikit-core';

const initFiltroClasesGrabadas = () => {
    const wrapper = document.querySelector('.mi-cuenta__clases-grabadas');
    if (!wrapper) return;

    const contenedor = wrapper.querySelector('.contenedor-clases-grabadas');
    const inputBuscar = document.querySelector('.buscador-input');

    if (!contenedor) return;

    const botonesMentor = wrapper.querySelectorAll('.filtro-clase-mentor');
    const botonesCategoria = wrapper.querySelectorAll('.filtro-clase-categoria');

    let mentor = '';
    let categoria = '';
    let search = '';
    let timeout = null;

    function filtrarClases(paged = 1) {
        contenedor.classList.add('loading');

        fetch('/wp-json/clases-grabadas-rest/v1/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce
            },
            body: JSON.stringify({
                data: {
                    mentor,
                    categoria,
                    search,
                    paged
                }
            })
        })
        .then(response => response.json())
        .then(response => {
            if (!response.success) return;

            contenedor.innerHTML = response.html;

            if (window.UIkit) {
                UIkit.update(contenedor);
            }

            activarPaginacionAjax();
            scrollToClases();
        })
        .catch(error => {
            console.error('Error filtrando clases grabadas:', error);
        })
        .finally(() => {
            contenedor.classList.remove('loading');
        });
    }

    function activarBoton(botones, botonActivo) {
        botones.forEach(btn => btn.classList.remove('active'));
        botonActivo.classList.add('active');
    }

    function actualizarTextoDropdown(boton, textoDefault) {
        const inline = boton.closest('.uk-inline');
        const span = inline?.querySelector('button.uk-button span');

        if (!span) return;

        if (
            boton.dataset.mentor === '' ||
            boton.dataset.categoria === ''
        ) {
            span.textContent = textoDefault;
        } else {
            span.textContent = boton.textContent.trim();
        }
    }

    function cerrarDropdown(boton) {
        const dropdownElement = boton.closest('.uk-inline')?.querySelector('[uk-dropdown]');

        if (dropdownElement && window.UIkit) {
            UIkit.dropdown(dropdownElement).hide(false);
        }
    }

    function scrollToClases() {
        const offset = 80;
        const top = wrapper.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top,
            behavior: 'smooth'
        });
    }

    botonesMentor.forEach(btn => {
        btn.addEventListener('click', function () {
            mentor = this.dataset.mentor || '';

            activarBoton(botonesMentor, this);
            actualizarTextoDropdown(this, 'Mentor');
            cerrarDropdown(this);

            filtrarClases(1);
        });
    });

    botonesCategoria.forEach(btn => {
        btn.addEventListener('click', function () {
            categoria = this.dataset.categoria || '';

            activarBoton(botonesCategoria, this);
            actualizarTextoDropdown(this, 'Tema');
            cerrarDropdown(this);

            filtrarClases(1);
        });
    });

    if (inputBuscar) {
        inputBuscar.addEventListener('input', function () {
            clearTimeout(timeout);

            search = this.value.trim();

            timeout = setTimeout(() => {
                filtrarClases(1);
            }, 350);
        });
    }

    function activarPaginacionAjax() {
        const links = contenedor.querySelectorAll('.clases-grabadas-paginacion a');

        links.forEach(link => {
            link.addEventListener('click', function (event) {
                event.preventDefault();

                const href = this.getAttribute('href');
                const url = new URL(href, window.location.origin);

                let paged = url.searchParams.get('paged');

                if (!paged) {
                    const match = href.match(/\/page\/([0-9]+)/);
                    paged = match ? match[1] : 1;
                }

                filtrarClases(parseInt(paged, 10) || 1);
            });
        });
    }

    activarPaginacionAjax();
};

export default initFiltroClasesGrabadas;